import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnHandle } from "../../../assets/icons";

const ColumnStep = () => {
  const { t } = useTranslation();
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 4fr", textAlign: "left" }}>
      <div></div>
      <p style={{ margin: "0px" }}>{t("walkthrough.3of4")}</p>
      <div></div>
      <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0px" }}>{t("walkthrough.column.title")}</p>
      <ColumnHandle style={{ justifySelf: "center" }} />
      <p style={{ margin: "0px", alignContent: "center" }}>{t("walkthrough.column.content")}</p>
    </div>
  );
};

export default ColumnStep;
